import { TDealType } from '@cian/api-models/offer-card/v1/get-offer-data';
import { BannerNew, EUserType, SuccessModal } from '@cian/demand-trap-widget';
import * as React from 'react';
import { ElementInViewport } from '../../../../common/components/elementInViewport';
import {
  EPriorityCommunicationChannel,
  ICreateMessageForOfferRequest,
} from '../../../../repositories/demand/v2/create-message-for-offer';
import { getApplicationFormQuery } from '../../utils/getApplicationFormQuery';
import { trackChangedUserType, trackSendFormClick } from '../../utils/tracking';

export interface IDemandFormData {
  name: string;
  email: string;
  phone: string;
  companyName?: string;
  userType?: string;
  hasAgentProfile?: boolean;
  priorityCommunicationChannel?: EPriorityCommunicationChannel;
}

export interface ITrapProps {
  isSuccessModalOpen: boolean;
  name?: string;
  email?: string;
  phone?: string;
  isHomeowner?: boolean;
  isAuthenticated?: boolean;
  dealType: TDealType;
  realtyType: string;
  roomCount?: string;
  realtyCategory: string;
  address: string;
  offerId: number;

  demandRequestCreateMessageStartAction(data: ICreateMessageForOfferRequest): void;

  demandCloseSuccessModalAction(): void;

  onShownInViewPort(visible: boolean): void;
}

export class TrapNew extends React.Component<ITrapProps, {}> {
  private isBannerVisibleTrackDone = false;

  private changeUserType = (userType: string) => {
    trackChangedUserType(userType);
  };

  private handleSubmitClick = (userType: string) => {
    trackSendFormClick(userType);
  };

  private handleFormSubmit = (formData: IDemandFormData) => {
    const { demandRequestCreateMessageStartAction, offerId } = this.props;

    const parameters: ICreateMessageForOfferRequest = {
      companyName: formData.companyName,
      email: formData.email,
      fullName: formData.name,
      hasAgentProfile: formData.hasAgentProfile,
      isHomeowner: formData.userType === 'homeowner',
      offerId,
      phone: formData.phone,
      priorityCommunicationChannel: formData.priorityCommunicationChannel,
      source: 'Card',
    };

    demandRequestCreateMessageStartAction(parameters);
  };

  private createMessage = (formData: IDemandFormData) => {
    const { userType, phone, email } = formData;
    const { realtyType, dealType, address, realtyCategory, roomCount } = this.props;

    if (userType === 'homeowner') {
      window.location.assign(
        `/application-form/${getApplicationFormQuery(
          phone,
          email,
          realtyType,
          realtyCategory,
          dealType,
          'after_similar',
          address,
          roomCount,
        )}`,
      );
    } else {
      this.handleFormSubmit(formData);
    }
  };

  private handleTrapShowInViewport = (visible: boolean) => {
    if (visible && !this.isBannerVisibleTrackDone) {
      this.props.onShownInViewPort(visible);
      this.isBannerVisibleTrackDone = true;
    }
  };

  public render() {
    const {
      isSuccessModalOpen,
      demandCloseSuccessModalAction,
      email,
      phone,
      isAuthenticated,
      isHomeowner,
    } = this.props;

    return (
      <div>
        <ElementInViewport onChange={this.handleTrapShowInViewport}>
          <BannerNew
            email={email}
            phone={phone}
            isAuthenticated={isAuthenticated}
            userType={isHomeowner ? EUserType.HomeOwner : EUserType.User}
            changeUserType={this.changeUserType}
            handleSubmitClick={this.handleSubmitClick}
            disclaimerText="Оставьте заявку, и с вами свяжется специалист"
            disclaimerHeader="Помощь надёжных риэлторов"
            createMessage={this.createMessage}
          />
        </ElementInViewport>
        {isSuccessModalOpen && <SuccessModal onCloseClick={demandCloseSuccessModalAction} />}
      </div>
    );
  }
}
